import React from "react";
import DefaultQuestionBody from "./DefaultQuestionBody";

const UnitFinderComponent = () => <DefaultQuestionBody />;

UnitFinderComponent.information = {
	type: "select",
	cayuseType: "unit-finder",
	name: "Unit Finder",
};

UnitFinderComponent.extraSettings = {
	tagsEnabled: false,
	preselectAll: false,
	enableAutocomplete: true,
	autocompleteMinLength: 1,
	dataSource: "Rest",
	queryUrl: "{{endpoints.cayuse}}/unit?search={{$searchText}}",
	lookupUrl: "{{endpoints.cayuse}}/unit/{{$id}}",
	linkTargetView: "browse",
	formatItem: "{{$item.name}}",
	storage: "Id",
	identity: "id",
	linkTarget: "_blank",
	multi: false
};

UnitFinderComponent.customOptions = [
	{
		label: "User can select multiple units",
		type: "multi"
	}
];

export default UnitFinderComponent;
